/**
 * Regra de liberação do módulo de Acessórios, compartilhada entre o menu
 * lateral (Menu.vue) e o bloqueio de acesso às telas (Layout.vue).
 *
 * São funções puras de propósito: quem chama já tem a config da concessionária
 * e os dados dela em mão. Resolver esses dados aqui dentro não funciona, porque
 * a concessionária só é definida no setup do Layout, depois da navegação.
 */

/**
 * Config keys com as listas de grupos e marcas liberados, com os códigos
 * separados por ";" - o padrão das keys do tipo tag. A lista padrão fica no
 * default_value e é editada em Ferramentas do Desenvolvedor > Habilitar
 * Acessórios. Um config_value da concessionária, do grupo, da marca
 * ou do DMS substitui a lista padrão para quem ele alcança (aparece como
 * exceção na mesma tela).
 */
export const ACESSORIOS_GRUPOS_KEY = "habilita_acessorios_grupo";
export const ACESSORIOS_MARCAS_KEY = "habilita_acessorios_marcas";

/** Converte o valor de uma key do tipo tag em lista de códigos. */
export const listaDeCodigos = (valor: unknown): string[] => {
  if (Array.isArray(valor))
    return valor.map((v) => String(v).trim()).filter(Boolean);

  if (typeof valor === "string")
    return valor
      .split(";")
      .map((v) => v.trim())
      .filter(Boolean);

  return [];
};

/**
 * O grupo E a marca da concessionária precisam estar nas listas das respectivas
 * config keys - as duas condições, não uma ou outra. Consequência: se qualquer
 * uma das duas listas estiver vazia, nenhuma concessionária é liberada.
 *
 * A comparação é feita como string porque os códigos chegam como number em
 * algumas telas e como string em outras.
 *
 * Retorna false quando falta config ou concessionária. Quem usa isso para
 * bloquear acesso precisa checar antes se os dois já chegaram - senão bloqueia
 * durante o carregamento.
 */
export const acessoriosLiberado = (
  config: any,
  concessionaria: any
): boolean => {
  if (!config || !concessionaria) return false;

  const grupos = listaDeCodigos(config[ACESSORIOS_GRUPOS_KEY]);
  const marcas = listaDeCodigos(config[ACESSORIOS_MARCAS_KEY]);

  const { codGrupo, codMarca } = concessionaria;

  const grupoLiberado = codGrupo != null && grupos.includes(String(codGrupo));
  const marcaLiberada = codMarca != null && marcas.includes(String(codMarca));

  return grupoLiberado && marcaLiberada;
};

export const PREFIXO_ROTAS_ACESSORIOS = "/acessorios";

export const ROTA_INICIAL_APENAS_ACESSORIOS = "acessorios-orcamentos";

export const usuarioApenasAcessorios = (
  usuario: { apenasAcessorios?: boolean | number } | null | undefined
): boolean => Boolean(usuario?.apenasAcessorios);
